import index from './index.vue'
const LQProgress: any = {};

// 注册组件
LQProgress.install = function (Vue) {
  /** 传参
   *  params: {
   *	   isNoMask: false, // 是否不显示遮罩层，默认值为false
   *     maskBackground: '' // 遮罩层背景样式
   *     percentage: 0, // 进度百分比，number类型
   *     type: 'line', // 进度条类型 'line' 'circle'，默认值为circle
   *  }
   */
  Vue.prototype.$LQProgress = ({
    isNoMask,
    maskBackground,
    percentage,
    type
  }: any = {}) => {
    const newConstructor = Vue.extend(index)
    const instance = new newConstructor();
    instance.isShow = true;
    instance.isNoMask = isNoMask || false;
    instance.maskBackground = maskBackground || '';
    instance.percentage = percentage || 0;
    instance.$mount(document.createElement('div'))
    if (type == 'line' && window.$(".l-grid-loading")[0]) {
      instance.type = 'line';
      instance.isNoMask = true;
      window.$(".l-grid-loading")[0].appendChild(instance.$el);
    } else {
      instance.type = 'circle';
      document.body.appendChild(instance.$el);
    }
    return instance;
  }
}

export default LQProgress;
